import React,{useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Card, CardContent, Typography, Accordion, AccordionSummary, AccordionDetails, Button, Stack,  CircularProgress } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
    fetchCompanyDetails,
    fetchCompanyFilings,
    setCompanyNumber
} from '../slices/chouseSlice.js'
import { 
    goForward, goBackward, fetchRecords, setPageSize, setColumns, markColumnsInitialized ,
    fetchCustomerEmails,setViewCustomerEmails, setRowData
} from '../slices/dataSlice';
import {ttpcolumns,  calloutcomes} from '../ttpcolumns.js'
import '../css/MobileCardView.css';
import {APIGetNotes, APIGetPhoneCalls} from '../APIS/wupuapAPI.js'
import parse from 'html-react-parser';
import CompanyHouseInfo from './CompanyHouseInfo'
import CompanyHouseFilings from './CompanyHouseFilings'
import MobileCompanyHeader from './MobileCompanyHeader'
import PageNavigator from './PageNavigator'
import MobileEmails from './MobileEmails';
import PopupCustomerEmails from './PopupCustomerEmails'



const MobileCardView = () => {
    const dispatch = useDispatch();
    const records = useSelector(state => state.data.records);
    const totalCount = useSelector(state => state.data.totalCount);

    const [columns,setColumns] = useState([])
    const forwardCursor = useSelector(state => state.data.forwardCursor);
    const backwardCursor = useSelector(state => state.data.backwardCursor);
    const auth = useSelector(state => state.auth)
    const { customerEmails, viewCustomerEmails,rowdata } = useSelector((state) => state.data);

    const [dataloaded,setDataLoaded] = useState(false)
    const [notes,setNotes] = useState([])
    const [phonecalls,setPhoneCalls] = useState([])
    const [rowid,setRowID] = useState(null)
    const [loading,setLoading] = useState(false)

    const summaryFields = ['CompanyName', 'FullName','date_created', 'lead_status'];
    const [expanded, setExpanded] = React.useState('panel1');
    const [moreexpanded,setMoreExpanded] = React.useState('');
    const [perPage,setPerPage] = useState(100)
    const [page,setPage] = useState(1)
    

    const changePage = (e) => {

    }

    const handleMoreChange = (panel, id ) =>  async (event, newExpanded) => {
        console.log(`${panel} / ${id}`)
        setRowID(id)
        const newexpanded = newExpanded ? panel : ""
        setMoreExpanded(newexpanded);
    }

    const handleChange =  (panel, id) =>  async (event, newExpanded) => {
        console.log(`${panel} / ${id}`)
        setRowID(id)
        const newexpanded = newExpanded ? panel : ""
        setExpanded(newexpanded);
        if(!newExpanded)
                return;

        setLoading(true)
        if(panel.substring(0,5) === 'notes')
            setLoading(true)
        if(panel.substring(0,5) === 'phone')
            setLoading(true)

    }

    useEffect(() => {
        const loadData = async () => {

            if(expanded.substring(0,5) === 'notes') {
                setLoading(true);
                const ret = await APIGetNotes({token: auth.token,ttp_lead_id: rowid});
                if(ret.status)
                    setNotes(ret.data)
                else
                    setNotes([])
                setLoading(false);
                setRowID(null)
            }
            if(expanded.substring(0,5) == 'phone') {
                setLoading(true);
                const ret = await APIGetPhoneCalls({token: auth.token,ttp_lead_id: rowid});
                if(ret.status)
                    setPhoneCalls(ret.data)
                else
                    setPhoneCalls([])
                setLoading(false);
                setRowID(null)
            }
            if(expanded.substring(0,7)=== 'company') {
                const srch = records.find(item => item.uid === rowid)
                if(srch) {
                    setLoading(true);
                    const company_number = srch["Company Number"]
                    dispatch(setCompanyNumber(company_number))
                    dispatch(fetchCompanyDetails());
                    dispatch(fetchCompanyFilings())
                    setLoading(false);
                    setRowID(null)
                }
            }
            if(expanded.substring(0,5)==='email') {
                setLoading(true);
                const srch = records.find(item => item.uid === rowid)
                if(srch) {
                    dispatch(setRowData(srch))
                    dispatch(fetchCustomerEmails(rowid));
                    dispatch(setViewCustomerEmails(true))
                }
                setLoading(false);
                setRowID(null)
                setExpanded("");
            }
        };
        if(rowid !== null  && expanded !== null && typeof expanded !== 'undefined')
           loadData();
      }, [expanded, rowid, records]);

    useEffect(()=> {
        function setUp() {

            dispatch(fetchRecords())

            const cols = ttpcolumns.map(item => ({
                field: item.field,
                headerName: item.headerName,
                type: item.type,
                editable: item.editable,
                hideable: item.hideable,
                visible: item.visible,
                valueGetter: item.valueGetter,
                valueFormatter: item.valueFormatter,
                renderCell: item.renderCell
            }));

            setColumns(cols)
            //dispatch(setColumns(JSON.stringify(cols)))
            dispatch(markColumnsInitialized(true));
            setDataLoaded(true)
        }
        if(!dataloaded)
            setUp();

    },[dataloaded])

    const getFieldLabel = (field) => {
        const col = columns.find(c => c.field === field);
        return col?.headerName || field;
    };

    const getDisplayValue = (col, row) => {
        if (!col) return '-';
        const baseParams = { row, field: col.field, value: row[col.field],  colDef: { computedWidth: col.width || 300 }  };
        if (col.valueGetter) return col.valueGetter(baseParams.value);
        if (col.renderCell)
            return (
                <>
                    <strong>{col.headerName || col.field}:&nbsp;</strong>
                    {col.renderCell(baseParams)}
                </>
            );
        return row[col.field] ?? '-';
    };

    const getRenderedCell = (col, row) => {
        const value = getDisplayValue(col, row);
        const baseParams = {
        row,
        field: col.field,
        value,
        colDef: { computedWidth: col.width || 300 } // fallback for mobile
        };
        if (col.renderCell)
        return (
            <>
                <strong>{col.headerName || col.field}:</strong>
                {col.renderCell(baseParams)}
            </>
        );
        return (
        <Typography key={col.field} variant="body2">
            <strong>{col.headerName || col.field}:</strong> {value}
        </Typography>
        );
    };

    // Page Number Update
    const handlePageUpdate = (newpage) => {
        if(newpage > page)
            handleNext();
        else if (newpage < page)
            handlePrevious();
        setPage(newpage);
    }
    // Per Page Update
    const handlePerPageUpdate = (newperpage) => {
        setPage(0);
        setPerPage(newperpage);
        dispatch(setPageSize(newperpage));
        dispatch(fetchRecords());
    }
    // Get Next Page of Data
    const handleNext = () => {
        if (forwardCursor) {
        dispatch(goForward(forwardCursor));
        dispatch(fetchRecords());
        }
    };
    // Get Previois Page of Data.
    const handlePrevious = () => {
        if (backwardCursor) {
        dispatch(goBackward(backwardCursor));
        dispatch(fetchRecords());
        }
    };

    return (
        <>
        <PopupCustomerEmails open={viewCustomerEmails} id={rowdata.uid} data={rowdata} uid={rowdata.id}  />
        <Box>
        <Stack spacing={2}>
            {records.map((row) => (
            <Card key={row.id} variant="outlined">
                <CardContent>
                {summaryFields.map(field => {
                    const col = columns.find(c => c.field === field);
                    return (
                    <Typography key={field} variant="subtitle1">
                        <strong>{getFieldLabel(field)}:</strong> {getDisplayValue(col, row)}
                    </Typography>
                    );
                })}
                <Accordion expanded={moreexpanded===`more_${row.id}`} onChange={handleMoreChange(`more_${row.id}`, row.uid)} >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="body2">More...</Typography>
                    </AccordionSummary>
                    <AccordionDetails>

                    <Accordion expanded={expanded===`details_${row.id}`} onChange={handleChange(`details_${row.id}`, row.uid)} >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="body2">View Details</Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                            {columns.filter(c => !summaryFields.includes(c.field) && c.visible === true).map(col => (
                            <Box key={col.field} mb={1}>
                                {getRenderedCell(col, row)}
                            </Box>
                            ))}
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expanded===`notes_${row.id}`} onChange={handleChange(`notes_${row.id}`, row.uid)} >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="body2">View Notes</Typography>
                            {loading && expanded ===`notes_${row.id}` && (
                                <CircularProgress
                                    size='3em'
                                    sx={{ ml: '10px' }}
                                    // Ensures spinner is right-aligned in summary
                                />
                            )}
                        </AccordionSummary>
                        <AccordionDetails>

                            {!loading && notes.map(note=>(
                                <Box key={`note_${note.note_id}`} mb={1}>
                                <span className='note_title' >Title: {note.title}</span><br/>
                                <span className='note_date'>Date: {new Date(note.datetime_added).toLocaleString()}</span><br/>
                                <span className='note_addedby'>Added By: {note.added_by}</span><br/>
                                {parse(`<div className='note_text'>${note.note.replaceAll('\n','<br/>')}</div><br/>`)}
                                <hr/>
                            </Box>
                            ))}
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expanded===`phonecalls_${row.id}`} onChange={handleChange(`phonecalls_${row.id}`, row.uid)} >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="body2">View Phone Calls</Typography>
                            {loading && expanded === `phonecalls_${row.id}` && (
                                    <Box sx={{ display: 'flex' }}>

                                <CircularProgress
                                    size='3em'
                                    sx={{ ml: '10px' }}
                                    // Ensures spinner is right-aligned in summary
                                />
                                                                  </Box>
                            )}
                        </AccordionSummary>
                        <AccordionDetails>
                            {!loading &&phonecalls.map(call=>(
                                <Box key={`call_${call.phonecall_uid}`} mb={1}>
                                <span className='note_title' >Number: {call.number_dialled}</span><br/>
                                <span className='note_date'>Date/Time: {call.datetime_dialled}</span><br/>
                                <span className='note_date'>Duration {call.call_durations} seconds</span><br/>
                                <span className='note_date'>Callback Set: {call.callback_set??"None"}</span><br/>
                                <span className='note_date'>Outcome: {call.call_outcome}</span><br/>
                                <span className='note_addedby'>Added By: {call.added_by}</span><br/>
                                {parse(`<div className='note_text'>${call.notes}</div><br/>`)}
                                <hr/>
                            </Box>
                            ))}
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expanded===`emails_${row.id}`} onChange={handleChange(`emails_${row.id}`, row.uid)} >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="body2">Customer Emails</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            {1===2 && (customerEmails??[]).length > 0 && expanded === `emails_${row.id}` && <MobileEmails emails={customerEmails} /> }
                        </AccordionDetails>
                    </Accordion>

                    <Accordion expanded={expanded===`companyinfo_${row.id}`} onChange={handleChange(`companyinfo_${row.id}`, row.uid)} >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="body2">Company House Info</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MobileCompanyHeader/>
                            <CompanyHouseInfo />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion expanded={expanded===`companyfilings_${row.id}`} onChange={handleChange(`companyfilings_${row.id}`, row.uid)} >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="body2">Company House Filings</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <MobileCompanyHeader/>
                            <CompanyHouseFilings />
                        </AccordionDetails>
                    </Accordion>
                </AccordionDetails >
                </Accordion>

                </CardContent>
            </Card>
            ))}
            <Box display="flex" justifyContent="space-between" pt={2}>
            <PageNavigator
                page={page}
                setPage={handlePageUpdate}
                totalPages={parseInt((totalCount/perPage)+0.99)}
                perPage={perPage}
                setPerPage={handlePerPageUpdate}
            />

            </Box>
        </Stack>
        </Box>
        </>
    );
};

export default MobileCardView;
